<template>
	<Combobox
		v-if="batchActionMenuOptions?.length"
		v-model="batchAction"
		as="div"
		class="relative w-full md:w-auto"
	>
		<div class="flex items-center w-full gap-2 flex-nowrap md:w-auto">
			<ComboboxButton
				:class="[buttonClasses, buttonBackgroundClasses, buttonTextClasses]"
				class="whitespace-nowrap w-full md:w-auto justify-center md:justify-normal inline-flex gap-x-1.5 items-center shadow px-4 py-2.5 rounded-lg"
			>
				<span :class="batchAction.id ? `after:content-[':']` : ''">
					<!-- TODO i18n -->
					{{ title }}
				</span>
				<span
					v-if="batchAction.id && !hideIdInLabel"
					class="text-mx-orange"
				>
					<!-- TODO i18n -->
					{{ batchAction.label }}
				</span>
				<ChevronDownIcon
					:class="[buttonTextClasses, 'w-5 h-5 -mr-1.5 -mt-0.5']"
					aria-hidden="true"
				/>
			</ComboboxButton>
			<ComboboxOptions class="top-[40px] absolute left-0 z-50 w-auto overflow-x-hidden mt-1 overflow-auto bg-white dark:bg-mx-green-800 rounded-md shadow-lg max-h-[500px]">
				<ComboboxOption
					v-for="option in batchActionMenuOptions"
					:key="option.id"
					v-slot="{ active, selected }"
					:value="option"
				>
					<div
						class="relative py-2 pl-4 pr-10 cursor-pointer select-none whitespace-nowrap"
						:class="[
							{ 'bg-mx-gray-100 dark:bg-mx-green-600 dark:text-white': active },
							{ 'text-black dark:text-mx-gray-300': !active }
						]"
					>
						{{ option.label }}
						<span
							v-if="selected"
							class="absolute inset-y-0 right-0 flex items-center pr-3"
						>
							✓
						</span>
					</div>
				</ComboboxOption>
			</ComboboxOptions>
		</div>
	</Combobox>
</template>

<script setup lang="ts">
import type { BatchAction } from '@/components/table/types'
import {
	Combobox,
	ComboboxButton,
	ComboboxOption,
	ComboboxOptions
} from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'

defineProps({
	batchActionMenuOptions: {
		type: Array as PropType<BatchAction[]>,
		required: true
	},
	buttonClasses: {
		type: String,
		default: ''
	},
	buttonBackgroundClasses: {
		type: String,
		default: 'bg-mx-gray-100 dark:bg-mx-green-800 hover:bg-mx-gray-200 dark:hover:bg-mx-green-600'
	},
	buttonTextClasses: {
		type: String,
		default: 'text-mx-gray-500 dark:text-mx-gray-300 text-sm font-semibold'
	},
	title: {
		type: String,
		default: 'Batch Action'
	},
	hideIdInLabel: {
		type: Boolean,
		default: false
	}
})
const batchAction = defineModel<BatchAction>({
	default: {
		id: '',
		text: ''
	}
})
</script>
